import { Box } from '@bechtel/gds';
import React from 'react';
import { EditCountField } from '~/components/molecules/edit-count-field';
import { ToolCatalogItemStyled } from './styled';
import { ToolFavorite } from './tool-favorite';
import { ToolCatalogItemProps } from './types';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { ImageFallback } from '~/components/image-fallback';
import { CatalogInfo } from '../catalog-info';
import RestrictedLimitComponent from '../molecules/restricted-limit';

export const ToolCatalogItem: React.FC<ToolCatalogItemProps> = ({
  count,
  toolCatalog,
  onItemCountChange,
  showFavoriteIcon = true,
  onFavoriteChange,
}) => {
  return (
    <ToolCatalogItemStyled>
      <Box px={{ sm: '500' }} py={{ sm: '500' }}>
        {showFavoriteIcon && (
          <Box>
            <ToolFavorite
              toolCatalogId={toolCatalog?.id}
              isToolFavorite={toolCatalog?.isFavorite}
              onFavoriteChange={onFavoriteChange}
            ></ToolFavorite>
          </Box>
        )}
        <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }} mx={{ sm: '600' }}>
          <ImageFallback src={toolCatalog?.toolCatalogImageUrl} fallbackName={toolCatalog?.toolCategory?.name} />
        </Box>
        <Box flexDirection={{ sm: 'column' }} style={{ flex: '1' }}>
          <CatalogInfo
            barCode={toolCatalog && toolCatalog.bscnPartNumber ? toolCatalog.bscnPartNumber : ''}
            description={toolCatalog && toolCatalog.name ? toolCatalog.name : ''}
            isSerialized={['Individual', 'equipment'].includes(toolCatalog?.inventoryType ?? '') ? true : false}
            uomAbbreviation={toolCatalog?.uom ? toolCatalog.uom.abbreviation : ''}
          />
        </Box>
        <Box flexDirection={{ sm: 'column' }} gap={{ sm: '200' }}>
          <EditCountField
            count={count}
            plusBtnDisable={
              toolCatalog?.projectToolCatalog[0]?.limitCount &&
              toolCatalog?.projectToolCatalog[0]?.limitCount > 0 &&
              count >= toolCatalog?.projectToolCatalog[0]?.limitCount
                ? true
                : false
            }
            onIncrement={() => {
              onItemCountChange(count + 1);
            }}
            onDecrement={() => {
              if (count > 0) {
                onItemCountChange(count - 1);
              }
            }}
            onCountTextChange={(countValue) => {
              if (
                toolCatalog?.projectToolCatalog[0]?.limitCount &&
                toolCatalog?.projectToolCatalog[0]?.limitCount > 0 &&
                countValue > toolCatalog?.projectToolCatalog[0]?.limitCount
              ) {
                return;
              }
              onItemCountChange(countValue);
            }}
          ></EditCountField>
          <RestrictedLimitComponent
            isLocked={toolCatalog?.projectToolCatalog[0]?.isLocked || false}
            limitCount={toolCatalog?.projectToolCatalog[0]?.limitCount || null}
          />
        </Box>
      </Box>
    </ToolCatalogItemStyled>
  );
};
